(function ($) {
	$("#toggle-menu-main").on("click", function () {
		const menuMain = $(".primary-menu__inner");
		if (menuMain.hasClass("active")) {
			$(this).removeClass("active");
			menuMain.removeClass("active");
			$("body").removeClass("main-menu-open");
		} else {
			$(this).addClass("active");
			menuMain.addClass("active");
			$("body").addClass("main-menu-open");
		}
	});

	function creteadScroller() {
		let lastKnownScrollPosition = 0;

		return () => {
			$(window).on("scroll", function () {
				window.requestAnimationFrame(function () {
					const top = $(window).scrollTop();
					const header = $('[data-elementor-type="header"]').height();
					const deltaY = window.scrollY - lastKnownScrollPosition;
					lastKnownScrollPosition = window.scrollY;

					if (top < header + 50) {
						$("body").removeClass("scroll-down");
						$("body").removeClass("scroll-up");
					} else {
						if (deltaY > 0) {
							$("body").addClass("scroll-down");
							$("body").removeClass("scroll-up");
						} else if (deltaY < 0) {
							$("body").removeClass("scroll-down");
							$("body").addClass("scroll-up");
						}
					}
				});
			});
		};
	}

	const scroll = creteadScroller();

	scroll();

	$(document).ready(function () {
		// Check viewport width on window load
		function checkWidth() {
			if ($(window).width() < 767) {
				// If viewport width is less than 768px, initialize the slider with slidesToShow: 1
				initSlider(1);
			} else if ($(window).width() < 1200) {
				// If viewport width is less than 1200px but greater than or equal to 768px, initialize the slider with slidesToShow: 2
				initSlider(2);
			} else {
				// If viewport width is greater than or equal to 1200px, destroy the slider
				destroySlider();
			}
		}

		// Function to initialize the slider with custom slidesToShow
		function initSlider(slidesToShow) {
			$(".change-mobile-to-slide").slick({
				// Your Slick slider options
				slidesToShow: slidesToShow,
				slidesToScroll: 1,
				autoplay: false,
				autoplaySpeed: 2000,
				dots: false,
				arrows: false,
				centerMode: false,
				// Add more options as per your requirements
			});
		}

		// Function to destroy the slider
		function destroySlider() {
			$(".change-mobile-to-slide").slick("unslick");
		}

		if ($(".change-mobile-to-slide").length > 0) {
			// Check viewport width on window resize
			$(window).on("resize", function () {
				checkWidth();
			});

			// Initial check on document ready
			checkWidth();
		}
	});

	//////// Custom slider top header ///////////////
	// Check if the cookie exists
	function checkCookie() {
		var visited = getCookie("visited");
		if (visited === "") {
			// Set the cookie to mark the visit
			setCookie("visited", "true", 365); // Expires in 365 days
		} else {
			// Add class to show the section
			document.getElementById("slide-top").classList.add("show-one-haft");
		}
	}
	// Function to set a cookie
	function setCookie(name, value, days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}
	// Function to get a cookie
	function getCookie(name) {
		var nameEQ = name + "=";
		var cookies = document.cookie.split(";");
		for (var i = 0; i < cookies.length; i++) {
			var cookie = cookies[i];
			while (cookie.charAt(0) == " ") {
				cookie = cookie.substring(1, cookie.length);
			}
			if (cookie.indexOf(nameEQ) == 0) {
				return cookie.substring(nameEQ.length, cookie.length);
			}
		}
		return "";
	}
	// Call the checkCookie function when the page loads
	window.onload = checkCookie;
})(jQuery);
